<div class="form-fields-theme">
    <div class="sign-in-text">SIGN UP</div>
    <p class="sign-in-subtext">
        Please fill details for <span>{{ mobileNumber }}</span>
    </p>

    <form name="signupForm" [formGroup]="signupForm" (submit)="signUp()">
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" type="text" required />
            @if (signupForm.get('name').hasError('minlength') || signupForm.get('name').hasError('required')) {
            <mat-error>
                Please enter valid Name(atleast 3 characters).
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" required />
            @if (signupForm.get('email').hasError('pattern') || signupForm.get('email').hasError('required')) {
            <mat-error>
                Please enter valid Email.
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field>
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" type="password" required
                autocomplete="new-password" />
            @if (signupForm.get('password').hasError('minlength') || signupForm.get('password').hasError('required')) {
            <mat-error>
                Please enter valid Password(atleast 6 characters).
            </mat-error>
            }
        </mat-form-field>
        <input type="submit" style="position: absolute; left: -9999px" />
    </form>

    <div class="btn-wrapper">
        <button btn-primary size="full" (click)="signUp()" [isLoading]="btnLoading">Continue</button>
    </div>

    <p class="login-terms">By signing up, you agree to the <span class="tnc" (click)="navigateToTnc()">
        Terms and Conditions</span>
    </p>
</div>